<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import { userService } from "../../../services/authservice/user.service";

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Change Password",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader,
    Button,
    Input
  },
  data() {
    return {
      password : "",
      confirm : ""

    };
  },
  mounted() {
    
  },

  methods: {
    submitSave: function() {
      if(this.password.length < 8){
        alert('សូមបញ្ជូលេខកូដយ៉ាងតិច ៨ខ្ទង់');
      }else if(this.password != this.confirm) {
        alert('លេខសម្ងាត់ និងការបញ្ជាក់មិនដូចគ្នាទេ សូមព្យាយាមម្តងទៀត');
      }else{
        let user = {
          password: this.password
        }
        userService.changePassword(user).then(response => {
          var sms = response.message;
          alert(sms);
          this.password = "";
          this.confirm = "";
        });
      }
    },
  }
};
</script>

<template>
  <Layout>
    
    <PageHeader :title="$t('navbar.dropdown.user.list.changePassword')" />
    <b-form  @submit.prevent="submitSave" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <Input 
                    :type="'password'"
                    v-model="password"
                    :label="'general.password'" 
                    :require="true"
                     /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'password'"
                    v-model="confirm"
                    :label="'general.confirm_password'" 
                    :require="true" />
                  </div>
                  <div class="col-md-3 mt-4">
                    <Button v-bind:icon="'bx bx-save bx-tada'" 
                      v-bind:buttonType="'button'"
                      @click="submitSave()"
                      v-bind:requesting="tryingToSubmit"
                      v-bind:title="$t('general.save')"  />
                  </div>
              </div>
          </div>
        </div>
      </div>
    </b-form>
  </Layout>
</template>